import styled from 'styled-components'
import { createPortal } from 'react-dom'
import { AnimatePresence, motion } from 'framer-motion'
import { Noto_body1_r16, Noto_subheading_b18 } from 'src/styles/font/NotoSansKrFonts'

import React from 'react'
import { Button } from 'src/components/Button'
import { ModalProps } from 'src/components/Modal/index'
import { ModalSpace } from 'src/components/Modal/provider'
import RenderIf from 'src/components/RenderIf'

const ModalView = ({ modalData, onSubmitInternal, onCancelInternal }: ModalProps) => {
  const { button, contents } = modalData as ModalSpace.ModalData
  const modalVars = {
    start: {
      opacity: 0,
      y: 100,
    },
    end: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        duration: 0.5,
      },
    },
    finish: {
      opacity: 0,
      y: -100,
      transition: {
        type: 'spring',
        duration: 0.5,
      },
    },
  }

  return createPortal(
    <React.Fragment>
      <AnimatePresence>
        <ModalBackGroundWrap />
      </AnimatePresence>
      <ModalWrap>
        <AnimatePresence>
          <ModalInner variants={modalVars} initial="start" animate="end" exit="finish">
            <ModalTitle $active={!!contents?.title}> {contents?.title}</ModalTitle>
            <ModalContents $active={!!contents?.desc}>{contents?.desc}</ModalContents>
            {contents?.children}
            <RenderIf when={!!button}>
              <ModalButtonWrap>
                <RenderIf when={!!button?.cancel}>
                  <Button.Default onClick={onCancelInternal}>{button?.cancel?.text}</Button.Default>
                </RenderIf>
                <RenderIf when={!!button?.submit}>
                  <Button.Primary onClick={onSubmitInternal}>{button?.submit?.text}</Button.Primary>
                </RenderIf>
              </ModalButtonWrap>
            </RenderIf>
          </ModalInner>
        </AnimatePresence>
      </ModalWrap>
    </React.Fragment>,
    document.body,
  )
}
export default ModalView

const ModalBackGroundWrap = styled(motion.div)`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
`
const ModalWrap = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`
const ModalInner = styled(motion.div)`
  width: 100%;
  min-width: 280px;
  max-width: 360px;
  padding: 26px 24px;
  background-color: #fff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 10px;
`

const ModalTitle = styled.strong<{
  $active: boolean
}>`
  ${Noto_subheading_b18};
  display: ${(props) => (props.$active ? ' block' : 'none')};
  text-align: center;
  line-height: 1.7;
  word-break: keep-all;
`
const ModalContents = styled.p<{
  $active: boolean
}>`
  ${Noto_body1_r16};
  display: ${(props) => (props.$active ? 'block' : 'none')};
  word-break: keep-all;
  white-space: break-spaces;
`

const ModalButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
`

export const ModalInnerScroll = styled.div`
  width: 100%;
  max-height: 212px;
  overflow: hidden;
  overflow-y: auto;
  background-color: var(--black-2);
  padding: 6px;
  border-radius: 12px;
  line-height: 1.4;
  margin-bottom: 16px;
  text-align: left;
  white-space: break-spaces;
`

export const ModalInnerText = styled.p`
  word-break: keep-all;
  line-height: 1.4;
`
